import React, { useMemo } from 'react';

import { fg } from '@atlaskit/platform-feature-flags';
import {
	isForgeAgentByCreatorType,
	type AgentCreatorType,
} from '@atlaskit/rovo-agent-components/common/utils/is-forge-agent';
import { AgentAvatar } from '@atlaskit/rovo-agent-components/ui/AgentAvatar';
import type { AppearanceType } from '@atlaskit/tag';

import type { EditorAgent } from '../../utils/agents';

type AgentRefinementTagProps =
	| { appearance: AppearanceType; elemBefore: React.ReactNode }
	| undefined;

export function useAgentRefinementTagProps(agent?: EditorAgent) {
	const props = useMemo<AgentRefinementTagProps>(() => {
		if (agent) {
			return {
				elemBefore: (
					<span data-testId="command-palette-rovo-agent-icon">
						<AgentAvatar
							agentId={agent.id}
							agentNamedId={agent.externalConfigReference ?? agent.namedId}
							agentIdentityAccountId={agent.identityAccountId}
							isForgeAgent={
								fg('rovo_agent_support_a2a_avatar')
									? isForgeAgentByCreatorType(agent.creatorType as AgentCreatorType)
									: agent.creatorType === 'FORGE'
							}
							forgeAgentIconUrl={agent.icon}
							label={agent.name}
							size="xsmall"
						/>
					</span>
				),
				appearance: 'rounded',
			};
		} else {
			return undefined;
		}
	}, [agent]);

	return props;
}
